import { createFileRoute } from '@tanstack/react-router'
import { EntityTypeQueries } from '@admin/data'
import EntityTypeAdmin from '@admin/preferences/EntityTypeAdmin'

export const Route = createFileRoute('/_auth/preferences/entityTypes/')({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(EntityTypeQueries.entityTypes())
  },
})

function RouteComponent() {
  return <EntityTypeAdmin />
}
